import { RiskTier } from '../../../Api/Projects/projectsApi';
import { TIER_CIRCLE_COLORS, TIER_SEVERITY } from '../ProjectManagementConfig/riskTierPresentation';

// Single hex source for the tier colors — defined with the admin Risk Configuration
// form so the widget family and the config preview can never drift apart.
export const RISK_TIER_SOLID_COLORS: Record<RiskTier, string> = TIER_CIRCLE_COLORS;

export const RISK_TIER_SEVERITY: RiskTier[] = TIER_SEVERITY;

// Account config can override these; used when an item carries no configured label.
export const RISK_TIER_DEFAULT_LABELS: Record<RiskTier, string> = {
  green: 'On Track',
  yellow: 'Possible Delay',
  red: 'Delayed'
};

export interface RiskBannerStyle {
  bg: string;
  border: string;
  icon?: string;
}

// Light banner palette per tier (the status strip above the dark widget card).
// Inline hex — the repo's Tailwind config overrides the red/yellow scalars, so bg-red-*/bg-yellow-* never generate.
export const RISK_TIER_BANNER_STYLES: Record<RiskTier, RiskBannerStyle> = {
  green: { bg: '#EDF8C3', border: '#DCE9A8' },
  yellow: { bg: '#FFF4BB', border: '#F0DC91', icon: RISK_TIER_SOLID_COLORS.yellow },
  red: { bg: '#FBE9E7', border: '#F3C7C1', icon: RISK_TIER_SOLID_COLORS.red }
};
